import configureMeasurements from "convert-units";
import allMeasures from "convert-units/definitions/all";
import { DeviceUnitItem } from "@/types/units/DeviceUnitItem";
import { UnitItem } from "@/types/units/UnitItem";
import { useCsv } from "./useCsv";

const { readCsvFile } = useCsv();

const DEVICE_UNITS_FILE = "./data/device_units.csv";
const UNITS_GUI_FILE = "./data/units_gui.csv";

export function useUnits() {
  const convert = configureMeasurements(allMeasures);
  // console.log(convert().possibilities()); // string[]

  async function getDeviceUnitsCsv(): Promise<DeviceUnitItem[] | null> {
    return readCsvFile<DeviceUnitItem>(DEVICE_UNITS_FILE);
  }

  async function getUnitsGuiCsv(): Promise<UnitItem[] | null> {
    return readCsvFile<UnitItem>(UNITS_GUI_FILE);
  }

  return {
    allMeasures,
    convert,
    getDeviceUnitsCsv,
    getUnitsGuiCsv,
  };
}
